import { Button, Input, Modal } from "antd";
import { useState } from "react";
import backIcon from "../../Assets/images/back-icon.svg";
import dollerSignIcon from "../../Assets/images/doller-sign.svg";
import PaymentSuccess from "./PaymentSuccess";

export default function PaymentDetails({ isModalOpen, setIsModalOpen, setShowChoosePlan }) {
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setShowChoosePlan(false)
    setShowPaymentSuccess(true)
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        closable={false}
        open={isModalOpen}
        footer={[
          <Button key="ok" type="primary" onClick={handleOk}>
            Make Payment
          </Button>,
        ]}
        className="hims-payment-details-card"
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img src={backIcon} width={32} height={26} onClick={handleCancel} />
          <div style={{ fontSize: "28px", fontWeight: "600" }}>
            Payment Details
          </div>
        </div>
        <div className="hims-input-container">
          <label className="hims-input-label">Email</label>
          <Input className="hims-input-field" placeholder="example@email.com" />
        </div>
        <div className="hims-input-container">
          <label className="hims-input-label">Credit Card Number</label>
          <Input
            className="hims-input-field"
            placeholder="xxxx xxxx xxxx xxxx"
          />
        </div>
        <div
          className="hims-input-container"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ width: "120px" }}>
            <label className="hims-input-label">Expiry Date</label>
            <Input className="hims-input-field" placeholder="00/00/00" />
          </div>
          <div style={{ width: "80px" }}>
            <label className="hims-input-label">CVV</label>
            <Input className="hims-input-field" placeholder="XXX" />
          </div>
        </div>
        <div>
          <div
            style={{ fontSize: "18px", fontWeight: "600", marginTop: "46px" }}
          >
            Amount to pay
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <img src={dollerSignIcon} alt="" />
            <span style={{ fontSize: "22px", fontWeight: "500" }}>00/m</span>
          </div>
        </div>
      </Modal>
      <PaymentSuccess
        isModalOpen={showPaymentSuccess}
        setIsModalOpen={setShowPaymentSuccess}
      />
    </>
  );
}
